
import React, { useEffect } from 'react';
import { motion } from "framer-motion";
import { ChangeSeo, ServicesSeo } from '../../utils/Seo';
import HeaderSeo from '../../components/HeaderSeo/Headerseo';
import Newnavigation from '../../components/new-navigation/new_navigation';
import ContactNew from '../../components/contact-form/ContactNew';
import Footer from '../../components/footer/Footer';
import {  CHANGE_AND_LEARNING_bg,  } from '../../assets/images';
import { ChangeAndLearnServicesBanner, } from '../../utils/servicebanner';
import AboutusBanner from '../../components/Aboutus-banner/AboutusBanner';
import ServiceSteps from '../../components/service-steps/ServiceSteps';
import { ChangeAndLearningOurMissons, ChangeAndLearningkeyService, ChangeAndLearningstepsdata } from '../../utils/services';
import OurMissions from '../../components/Our-missions/OurMissions';
import ServicesKey from '../../components/services-key/ServicesKey';

const ChangeAndLearning = () => {
    useEffect(() => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      }, []);
      return (
        <motion.div initial={{ opacity: 0 }}animate={{ opacity: 1, transition: { duration: 1 } }}>
        <div className='service-page '>
            <HeaderSeo data={ChangeSeo}/>
            <Newnavigation routeName="services"/>
            <AboutusBanner bg={CHANGE_AND_LEARNING_bg} data={ChangeAndLearnServicesBanner}/>
            <ServiceSteps title="Transform, Adapt, and Thrive" stepsData={ChangeAndLearningstepsdata}/>
             <OurMissions  data={ChangeAndLearningOurMissons} />
              <ServicesKey data={ChangeAndLearningkeyService} />
            <ContactNew />
            <Footer />
        </div>
        </motion.div>
    )
}

export default ChangeAndLearning